'use strict';
define('tracking',[
    'skr/tracking/dispatchGtmEvent',
    'skr/tracking/pageView',
    'skr/tracking/selectItem',
    'skr/tracking/useSearch',
    'skr/tracking/viewItemList',
    'skr/tracking/awinTracking',
], function() {
});

